import $ from "jquery";
window.$ = window.jQuery = $;
require('./swiper');
require('./form');
require('./filter');
import Inputmask from "inputmask";
import 'jquery-validation';

$(document).ready(function () {

    const im = new Inputmask("+(380) 99-999-99-99");
    im.mask($('input[name="phone"]'));

    $('.faq__item').click(function () {
        $(this).find('.faq__content').slideToggle()
        $(this).find('.accordion__icon').toggleClass('active')
    });
    $('.header__active-lang').click(function () {
        $('.header__lang-list-wrap').slideToggle()
    });

    $('.left-bar__burger-wrap').click(function () {
        $(this).find('.left-bar__burger-item').toggleClass('active')
        $('.left-bar__menu-wrap').toggle()
    });

    $('.left-bar__link-btn').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.left-bar__item').find('.left-bar__list-second').hide();
        } else {
            $('.left-bar__list-second').hide();
            $('.left-bar__link-btn').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.left-bar__item').find('.left-bar__list-second').show();
        }
    });

    $('.left-bar__link-second-btn').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.left-bar__item-second').find('.left-bar__list-third').hide()
        } else {
            $('.left-bar__list-third').hide()
            $('.left-bar__link-second-btn').removeClass('active')
            $(this).addClass('active')
            $(this).closest('.left-bar__item-second').find('.left-bar__list-third').show()
        }
    });

    $('.main-wrap').click(function () {
        $('.left-bar__menu-wrap').hide()
        $('.left-bar__list-second').hide()
        $('.left-bar__list-third').hide()
        $('.left-bar__burger-item').removeClass('active')
        $('.left-bar__link-btn').removeClass('active')
        $('.left-bar__link-second-btn').removeClass('active')

        $('.menu__list-second').hide()
        $('.menu__list-third').hide()
        $('.menu__link-btn').removeClass('active')
        $('.menu__link-second-btn').removeClass('active')
    });

    $('.menu__link-btn').click(function () {
        const el = $(this).closest('.menu__item').find('.menu__list-second');
        const isOpen = el.is(':visible');

        $('.menu__link-btn').removeClass('active')
        $('.menu__list-second').hide()

        if (isOpen) return;


        $(this).closest('.menu__item').find('.menu__list-second').toggle()
        $(this).toggleClass('active')

        let menuText = $(this).text().trim();
        $('.menu__back-btn-second').text(menuText)
    });

    $('.menu__link-second-btn').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.menu__item-second').find('.menu__list-third').hide()
        } else {
            $('.menu__list-third').hide()
            $('.menu__link-second-btn').removeClass('active')
            $(this).toggleClass('active')
            $(this).closest('.menu__item-second').find('.menu__list-third').show()

            let menuSecondText = $(this).text().trim();
            $('.menu__back-btn-third').text(menuSecondText)
        }
    });

    $('.menu__back-btn').click(function () {
        $(this).closest('.js__close-menu').hide()
        $(this).closest('.menu__item').find('.menu__link-btn').removeClass('active')
    });

    $('.header__burger-item').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            $('.menu').removeClass('active')
            $('body').removeClass('hidden')
            $('.menu__list-second').hide()
            $('.menu__list-third').hide()
        } else {
            $(this).addClass('active')
            $('.menu').addClass('active')
            $('body').addClass('hidden')
        }
    });
});


$(document).on('click', '.js_actevate_video', function () {
    const btn = $(this);
    const type = btn.attr('data-type');
    const src = btn.attr('data-src');
    let htmlVideo = '';

    switch (type) {
        case 'video':
        htmlVideo = `<video width="100%" height="auto" controls autoplay> <source src="${src}" type="video/mp4"> Your browser does not support the video tag. </video>`;
        break;
        case 'iframe':
        htmlVideo = `<iframe allowfullscreen src="${src}?autoplay=1" width="100%" height="auto"></iframe>`;
        break;
    }
    $('.js_append_video').addClass('active');
    $('.modal-video__wrap').empty().append(htmlVideo);
});

$(document).on('click', '.modal-video', function () {
    $('.js_append_video').removeClass('active');
    $('.modal-video__wrap').empty();
});
